var map = {
	"./mobile-header-ar.mp4": "8a8b",
	"./mobile-header-by.mp4": "6c1e",
	"./mobile-header-global.mp4": "e13a",
	"./mobile-header-global_.mp4": "acb5",
	"./mobile-header-kz.mp4": "eff4",
	"./mobile-header-ru.mp4": "d067",
	"./mobile-header-ru_.mp4": "a670"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ad25";